namespace GeniuzPOS.Lookups {
    export interface LookupBgColorRow {
        Id?: number;
        BgColor?: string;
        BgColorName?: string;
    }

    export namespace LookupBgColorRow {
        export const idProperty = 'BgColor';
        export const nameProperty = 'BgColorName';
        export const localTextPrefix = 'Lookups.LookupBgColor';
        export const lookupKey = 'Lookups.LookupBgColor';

        export function getLookup(): Q.Lookup<LookupBgColorRow> {
            return Q.getLookup<LookupBgColorRow>('Lookups.LookupBgColor');
        }
        export const deletePermission = '*';
        export const insertPermission = '*';
        export const readPermission = '*';
        export const updatePermission = '*';

        export declare const enum Fields {
            Id = "Id",
            BgColor = "BgColor",
            BgColorName = "BgColorName"
        }
    }
}
